import { createAsyncThunk } from "@reduxjs/toolkit";
import SafetyVideoService from "../services/SafetyVideoServices";

export const addVideo = createAsyncThunk("/safety-video", async (payload) => {
  const res = await SafetyVideoService.addVideo(payload);
  return res.data;
});

export const getSafetyVideo = createAsyncThunk(
  "/safety-video",
  async (payload) => {
    const res = await SafetyVideoService.getSafetyVideo(payload);
    return res.data;
  }
);

export const getCompanySafetyVideo = createAsyncThunk(
  "/safety-video",
  async (payload) => {
    const res = await SafetyVideoService.getCompanySafetyVideo(payload);
    return res.data;
  }
);

export const updateSafetyVideo = createAsyncThunk(
  "/safety-video",
  async (payload) => {
    const res = await SafetyVideoService.updateSafetyVideo(payload);
    return res.data;
  }
);
